import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { isEmpty, guid } from '@/utils';
import { getCityList, getCinemaList, getMovieList } from '../../api';
import { getPictureByKey } from '@/views/custom-layout/api';
export default {
  components: {
    uploadFile: uploadFile,
    draggable: draggable,
    pictureLibrary: pictureLibrary
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isEmpty: isEmpty,
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      cinemaObj: {},
      movieList: [],
      cityList: [],
      showPictureLibrary: false,
      pictureList: [],
      depot: {},
      updateIndex: 0
    };
  },
  methods: {
    onUpload: function onUpload(index) {
      this.$refs.uploadBanner[index].uploadBanner();
    },
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config.value[this.updateIndex]['imageurl'] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(index) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.showPictureLibrary = true;
    },
    changeCity: function changeCity(item, city_id, uid, clear_link_value) {
      var _this2 = this;
      if (isEmpty(city_id)) {
        this.$set(item, 'city_id', []); // 老数据兼容
        this.$set(this.cinemaObj, uid, []);
        return;
      }
      if (clear_link_value) {
        item.link_value = '';
      }
      var _city_id = _slicedToArray(city_id, 3),
        _city_id$ = _city_id[0],
        province_id = _city_id$ === void 0 ? '' : _city_id$,
        _city_id$2 = _city_id[1],
        region_id = _city_id$2 === void 0 ? '' : _city_id$2,
        _city_id$3 = _city_id[2],
        area_id = _city_id$3 === void 0 ? '' : _city_id$3;
      getCinemaList({
        province_id: province_id,
        region_id: region_id,
        area_id: area_id
      }, this.info.module).then(function (res) {
        _this2.$set(_this2.cinemaObj, uid, res.data);
      });
    },
    loadList: function loadList() {
      var _this3 = this;
      getCityList().then(function (res) {
        _this3.cityList = res.data.tree.map(function (i) {
          return _objectSpread(_objectSpread({}, i), {}, {
            disabled: true
          });
        });
      });
      getMovieList({}, this.info.module).then(function (res) {
        _this3.movieList = res.data;
      });
    },
    radioChange: function radioChange(item) {
      item.link_value = '';
    },
    addUpload: function addUpload() {
      this.value.config.value.push({
        imageurl: '',
        link_type: '1',
        city_id: [],
        link_value: '',
        sort: '',
        uid: guid()
      });
    },
    emitUploadFile: function emitUploadFile(res, item) {
      item.imageurl = "".concat(this.$ossurl).concat(res);
    },
    //删除图片
    handleDelUpload: function handleDelUpload(index) {
      var _this4 = this;
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this4.value.config.value.splice(index, 1);
      });
    }
  },
  created: function created() {
    var _this5 = this;
    this.loadList();
    this.getPicture();
    if (isEmpty(this.value.config.value)) {
      this.$set(this.value, 'config', {
        width: '750',
        height: '280',
        value: [{
          imageurl: '',
          link_type: '1',
          city_id: [],
          link_value: '',
          sort: '1',
          uid: guid()
        }]
      });
    } else {
      this.value.config.value.forEach(function (item) {
        item.uid = item.uid ? item.uid : guid();
        _this5.changeCity(item, item.city_id, item.uid);
      });
    }
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index //兼容新老组件 默认预置2
    }));
  },
  computed: {
    list: function list() {
      return {
        1: this.movieList,
        2: this.cinemaObj
      }[this.value.config.link_type] || [];
    }
  }
};